import axios from 'axios';

// Lealtad (propuesta integral Fase 2). El baseURL de axios ya incluye /{tenant}/.
export default {
  getCustomerLoyalty(customerId) {
    return axios.get(`/customers/${customerId}/loyalty`);
  },
  getLedger(customerId, params) {
    return axios.get(`/customers/${customerId}/loyalty/ledger`, { params });
  },
  adjust(payload) {
    return axios.post('/loyalty/adjust', payload);
  },
  getTiers() {
    return axios.get('/loyalty/tiers');
  },
  createTier(data) {
    return axios.post('/loyalty/tiers', data);
  },
  updateTier(id, data) {
    return axios.put(`/loyalty/tiers/${id}`, data);
  },
  runJob(name) {
    return axios.post(`/jobs/${name}`);
  }
}
